import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { ShowEmployeesModeSelectorProps } from '~/scenes/PortalModules/Analytics/People/AbsenceCalendarReport/ShowEmployeesModeSelector/component';

type PropsType = {
  hasNonAbsentEmployees: boolean;
  hasAbsentEmployees: boolean;
};

export const useShowEmployeesModeSelector = (
  props: PropsType,
): ShowEmployeesModeSelectorProps => {
  const { hasNonAbsentEmployees, hasAbsentEmployees } = props;

  const { t } = useTranslation();

  const showEmployeesModeOptions: Enum[] = [
    {
      code: 'ALL',
      name: t('label_all'),
    },
    {
      code: 'ABSENCES',
      name: t('laAbsences'),
    },
  ];
  const [showEmployeesMode, setShowEmployeesMode] = useState<string>('ALL');

  const disabledShowEmployeesModeSelector =
    !hasNonAbsentEmployees || !hasAbsentEmployees;
  useEffect(() => {
    if (showEmployeesMode !== 'ALL' && disabledShowEmployeesModeSelector) {
      setShowEmployeesMode('ALL');
    }
  }, [showEmployeesMode, disabledShowEmployeesModeSelector]);

  return {
    value: showEmployeesMode,
    options: showEmployeesModeOptions,
    setValue: setShowEmployeesMode,
    disabled: disabledShowEmployeesModeSelector,
  };
};
